// hooks/usePostModals.ts
import { Post } from "@/core/types/postTypes";
import { MediaItem } from "@/core/MediaItem/MediaItem.model";
import { useAppStore } from "@/core/store/useAppStore";

export const usePostModals = () => {
  const { setActiveModal, ui } = useAppStore();

  const openCreateModal = () => {
    setActiveModal("post-creator", { mode: "create" });
  };

  const openCreateModalWithMedia = (mediaItems: MediaItem[]) => {
    setActiveModal("post-creator", {
      mode: "create",
      preSelectedMediaItems: mediaItems,
      contentType: "post",
    });
  };

  const openCreateModalForIdea = (ideaId: string, clientId: string) => {
    setActiveModal("post-creator", { mode: "create", linkToIdeaId: ideaId, linkToIdeaClientId: clientId });
  };

  const openEditModal = (post: Post) => {
    setActiveModal("post-creator", { mode: "edit", editingPost: post });
  };

  const openReelModal = (post: Post) => {
    setActiveModal("post-creator", { mode: "edit", editingPost: post, contentType: "reel" });
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  return {
    openCreateModal,
    openCreateModalWithMedia,
    openCreateModalForIdea,
    openEditModal,
    openReelModal,
    closeModal,
    // Helper to get current modal props
    modalProps: ui.activeModal?.props,
  };
};
